import { useState, useEffect } from "react"
import { useUpdateUserMutation, useDeleteUserMutation } from "./usersApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { ROLES } from "../../config/roles"

const USER_REGEX = /^[A-z0-9]{5,20}$/
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/

const EditUserForm = ({ user, groups:groupsProps }) => {
    const {groupId, type} = useParams()
    const [updateUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateUserMutation()

    const [deleteUser, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteUserMutation()

    const navigate = useNavigate()

    const [username, setUsername] = useState(user.username)
    const [validUsername, setValidUsername] = useState(false)
    const [password, setPassword] = useState('')
    const [validPassword, setValidPassword] = useState(false)
    const [email, setEmail] = useState(user.email)
    const [name, setName] = useState(user.name)
    const [phone, setPhone] = useState(user.phone)
    const [groups, setGroups] = useState(user.groups)
    const [roles, setRoles] = useState(user.roles)
    const [active, setActive] = useState(user.active)

    useEffect(() => {
        setValidUsername(USER_REGEX.test(username))
    }, [username])

    useEffect(() => {
        setValidPassword(PWD_REGEX.test(password))
    }, [password])

    useEffect(() => {
        if (isSuccess || isDelSuccess) {
            setUsername('')
            setPassword('')
            setEmail('')
            setName('')
            setPhone('')
            setGroups([])
            setRoles([])
            navigate(`/${type}/${groupId}/users`)
        }

    }, [isSuccess, isDelSuccess, navigate])

    const onUsernameChanged = e => setUsername(e.target.value)
    const onPasswordChanged = e => setPassword(e.target.value)

    const onRolesChanged = e => {
        const values = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        )
        setRoles(values)
    }
    const onGroupChanged = e => {
        const values = Array.from(
            e.target.selectedOptions, //HTMLCollection 
            (option) => option.value
        )
        setGroups(values)
    }
    const onActiveChanged = () => setActive(prev => !prev)

    const onSaveUserClicked = async (e) => {
        if (password) {
            await updateUser({ id: user.id, username, password, name, email, phone, groups, roles, active })
        } else {
            await updateUser({ id: user.id, username,  name, email, phone, groups, roles, active })
        }
    }

    const onDeleteUserClicked = async () => {
        await deleteUser({ id: user.id })
    }

    const options = Object.values(ROLES).map(role => {
        return (
            <option
                key={role}
                value={role}

            > {role}</option >
        )
    })

    const groupsOptions = groupsProps.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

    let canSave
    if (password) {
        canSave = [roles.length, groups.length, validUsername, validPassword , name,email].every(Boolean) && !isLoading
    } else {
        canSave = [roles.length, groups.length, validUsername , name,email].every(Boolean) && !isLoading
    }

    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
    const validUserClass = !validUsername ? 'form__input--incomplete' : ''
    const validPwdClass = password && !validPassword ? 'form__input--incomplete' : ''
    const validRolesClass = !Boolean(roles.length) ? 'form__input--incomplete' : ''
    const validGroupsClass = !Boolean(groups.length) ? 'form__input--incomplete' : ''

    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit User</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/users`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveUserClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                            className="icon-button"
                            title="Delete"
                            onClick={onDeleteUserClicked}
                        >
                            <FontAwesomeIcon icon={faTrashCan} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="username">
                    Username: <span className="nowrap">[3-20 letters]</span></label>
                <input
                    className={`form__input ${validUserClass}`}
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="off"
                    value={username}
                    onChange={onUsernameChanged}
                />

                <label className="form__label" htmlFor="password">
                    Password: <span className="nowrap">[empty = no change]</span> <span className="nowrap">[4-12 chars incl. !@#$%]</span></label>
                <input
                    className={`form__input ${validPwdClass}`}
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={onPasswordChanged}
                />
                
<label className="form__label" htmlFor="name">
                    Name: </label>
                <input
                    className={`form__input ${!name &&'form__input--incomplete'}`}
                    id="name"
                    name="name"                    
                    type="text"
                    value={name}
                    onChange={(e)=>{setName(e.target.value)}}
                />
<label className="form__label" htmlFor="email">
                    Email: </label>
                <input
                    className={`form__input ${!email &&'form__input--incomplete'}`}
                    id="email"
                    email="email"                    
                    type="email"
                    value={email}
                    onChange={(e)=>{setEmail(e.target.value)}}
                />

<label className="form__label" htmlFor="phone">
                    Phone: </label>
                <input
                    className={`form__input`}
                    id="phone"
                    name="phone"                    
                    type="text"
                    value={phone}
                    onChange={(e)=>{setPhone(e.target.value)}}
                />

                <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={onActiveChanged}
                    />
                </label>

                <label className="form__label" htmlFor="roles">
                    ASSIGNED ROLES:</label>
                <select
                    id="roles"
                    name="roles"
                    className={`form__select ${validRolesClass}`}
                    multiple={true}
                    size="3"
                    value={roles}
                    onChange={onRolesChanged}
                >
                    {options}
                </select>
                <label className="form__label" htmlFor="roles">
        Groups:</label>
    <select
        id="groups"
        name="groups"
        className={`form__select ${validGroupsClass}`}
        multiple={true}
        size="3"
        value={groups}
        onChange={onGroupChanged}
    >
        {groupsOptions}
    </select>

            </form>
        </>
    )

    return content
}
export default EditUserForm